module.exports = __webpack_public_path__ + "img/banner_games_new.4ed1a594.png";